
import React, { useState, useEffect } from 'react';
import DashboardHeader from '../shared/components/DashboardHeader';
import SideMenu from '../shared/components/SideMenu';
import Footer from '../shared/components/Footer';

import HttpCall from '../api/Http';
import SerializeClass from '../shared/Utils/serialized';
import User from '../shared/Utils/User';
import axios from 'axios';
import Alert from '../shared/Utils/AlertBox';
import Loader from '../shared/components/Loader';
import Moment from 'react-moment';

export default function Opportunities() {

    const user = User.getUser();
    const [leadList, setLeadList] = useState([])
    const [stageID, setStageID] = useState(0)
    const [leadID, setLeadID] = useState(0)
    const [loader, setLoader] = useState(false);
    const [recordID, setRecordID] = useState(0);
    const [opportunityList, setOpportunityList] = useState([])
    const [inputValue, setInputValue] = useState({ opputunity_name: "", amount: "", customer_name: user[0].First_Name + ' ' + user[0].Last_Name, close_date: new Date(Date.now()).toISOString().split('T')[0], account_name: "" });
    const { opputunity_name, amount, customer_name, account_name, close_date } = inputValue;

    const handleChange = (e) => {
        const { name, value } = e.target;
        setInputValue((prev) => ({ ...prev, [name]: value, }));
    };

    useEffect(() => {
        getOppurtunityList();
        let arr = [];
        arr.push({ P_user_id: user[0].Id });
        let p = SerializeClass.getSerializedData(arr);
        let header = {
            headers: { 'Authorization': `Token ${user[0].token}` }
        };

        let url2 = `https://api.getbound.ai/api/user/getLeadList?Params=${p}`;
        axios.get(url2, header).then(response => {
            if (response.data.code == 200) {
                setLeadList(response.data.data);
            } else {
                alert(response.data.msg);
            }
        }).catch(err => {
            console.log(err);
        })
    }, [])

    const getOppurtunityList = () => {
        let arr = [];
        arr.push({ P_user_id: user[0].Id });
        let p = SerializeClass.getSerializedData(arr);
        let header = {
            headers: { 'Authorization': `Token ${user[0].token}` }
        };
        let url = `https://api.getbound.ai/api/user/getOpportunities?Params=${p}`;
        axios.get(url, header).then(response => {
            if (response.data.code == 200) {
                setOpportunityList(response.data.data);
            } else {
                alert(response.data.msg);
            }
        }).catch(err => {
            console.log(err);
        })
    }

    function selectedLead(e) {
        const select = e.target;
        setLeadID(select.children[select.selectedIndex].value);
    }

    function selectedStage(e) {
        const select = e.target;
        setStageID(select.children[select.selectedIndex].value);
    }

    function maxLengthCheck (object) {
        if (object.target.value.length > object.target.maxLength) {
            object.target.value = object.target.value.slice(0, object.target.maxLength)
        }
    }

    function addOpportunity(e) {

        e.preventDefault();

        let requestData = new FormData();
        let arr = [];
        arr.push({ P_lead_list_id: leadID });
        arr.push({ P_amount: amount });
        arr.push({ P_opportunity_name: opputunity_name });
        arr.push({ P_close_date: close_date });
        arr.push({ P_stage: stageID });
        arr.push({ P_company_name: account_name });
        arr.push({ P_customer_name: user[0].First_Name + ' ' + user[0].Last_Name });

        if (recordID > 0) {
            arr.push({ P_id: recordID });
            arr.push({ P_updated_by: user[0].Id });
        } else {
            arr.push({ P_created_by: user[0].Id });
        }



        let p = SerializeClass.getSerializedData(arr);
        let url = recordID ? '/api/user/updateOpportunity' : `/api/user/addOpportunity`
        requestData.append('Params', p);
        setLoader(true);
        HttpCall.postRequest2(url, requestData).then(response => {
            if (response.data.code == 200) {
                Alert.show("Success!", leadID ? "Oppurtunity Updated Successfully." : "Oppurtunity Added Successfully.", "success");
                window.location.reload(false);
            } else {
                Alert.show("Error!", response.data.msg, "error");
            }
            setLoader(false);
        }).catch(err => {
            console.log(err);
            setLoader(false);
        })
    }

    function editOppurtunity(row) {
        setRecordID(row.id);
        setStageID(row.stage);
        setLeadID(row.lead_list_id);
        setInputValue(() => ({
            opputunity_name: row.opportunity_name,
            amount: row.amount,
            customer_name: row.customer_name,
            account_name: '',
            close_date: new Date(row.close_date).toLocaleDateString('en-CA'),
            account_name: row.company_name,
        }))
    }




    return (
        <>
            <DashboardHeader />
            {loader && <Loader />}
            <div className="container-fluid page-body-wrapper">
                <SideMenu />
                <div className="main-panel">
                    <div className="content-wrapper">
                        <div className="row">

                            <div className="col-md-12 grid-margin stretch-card">
                                <div className="card">
                                    <div className="card-body">
                                        <h4 className="card-title">Opportunities > Add Opportunity</h4>
                                        <p className="card-description">
                                            Note: Add Opportunities of your potential accounts
                                        </p>
                                        <form className="forms-sample">

                                            <div className="form-group">
                                                <label>Opportunity Name</label>
                                                <input type="text" className="form-control form-control-lg"
                                                    placeholder="Enter Opportunity Name" autocomplete="off"
                                                    name="opputunity_name" value={opputunity_name} onChange={handleChange} />
                                            </div>

                                            <div className="row">
                                                <div className="col-md-6">
                                                    <div className="form-group">
                                                        <label>Amount</label>
                                                        <input type="number" maxLength="10" onInput={maxLengthCheck} className="form-control form-control-lg" placeholder="Enter Amount"
                                                            name="amount" value={amount}
                                                            onChange={handleChange}
                                                        />
                                                    </div>
                                                </div>
                                                <div className="col-md-6">
                                                    <div className="form-group">
                                                        <label>Stage</label>
                                                        <select value={stageID} onChange={selectedStage} className="js-example-basic-single w-100 customselect form-control form-control-lg form-control form-control-lg">
                                                            <option value="">Select Stage</option>
                                                            <option value="Qualification">Qualification</option>
                                                            <option value="Need Analysis">Need Analysis</option>
                                                            <option value="Proposal">Proposal</option>
                                                            <option value="Negotiation">Negotiation</option>
                                                            <option value="Closed Won">Closed Won</option>
                                                        </select>
                                                    </div>
                                                </div>
                                            </div>
                                            <div className="row">

                                                <div className="form-group">
                                                    <label>Customer Name</label>
                                                    <input type="text" className="form-control form-control-lg" placeholder="Enter Customer Name"
                                                        name="customer_name" value={customer_name} onChange={handleChange} />
                                                </div>
                                            </div>

                                            <div className="row">
                                                <div className="col-md-6">
                                                    <div className="form-group">
                                                        <label>Lead List</label>
                                                        <select className="js-example-basic-single w-100 customselect form-control form-control-lg"
                                                            onChange={selectedLead} value={leadID}>
                                                            <option value="">Select Lead List</option>
                                                            {leadList.map(data => (
                                                                <option key={data.id} value={data.id}>
                                                                    {data.lead_list_name}
                                                                </option>
                                                            ))}
                                                        </select>
                                                    </div>
                                                </div>
                                                <div className="col-md-6">
                                                    <div className="form-group">
                                                        <label>Close Date</label>
                                                        <input type="date" className="form-control form-control-lg"
                                                            name="close_date" value={close_date} onChange={handleChange} />
                                                    </div>
                                                </div>
                                            </div>



                                            <div className="form-group">
                                                <label>Account / Company Name</label>
                                                <input type="text" className="form-control form-control-lg"
                                                    placeholder="Enter Company Name"
                                                    name="account_name" value={account_name} onChange={handleChange} />
                                            </div>


                                            <div className="row">
                                                <div className="col-md-6">
                                                    <button type="submit" className="btn btn-primary me-2 savebtn"
                                                        onClick={addOpportunity}>Create</button>
                                                </div>
                                                <div className="col-md-6">
                                                    <button className="btn btn-light me-2 savebtn">Cancel</button>
                                                </div>
                                            </div>

                                        </form>
                                    </div>
                                </div>
                            </div>


                            <div className="col-lg-12 grid-margin stretch-card">
                                <div className="card">
                                    <div className="card-body">
                                        <h4 className="card-title">Opportunities </h4>

                                        <div className="table-responsive">
                                            <table className="table">
                                                <thead>
                                                    <tr>
                                                        <th>#</th>
                                                        <th>Opportunity Name</th>
                                                        <th>Amount</th>
                                                        <th>Stage</th>
                                                        <th>Customer Name</th>
                                                        <th>Account</th>
                                                        <th>Close Date</th>
                                                        <th>Action</th>
                                                    </tr>
                                                </thead>
                                                <tbody>
                                                    {opportunityList.length > 0 && opportunityList.map((data, index) => (<tr key={index}>
                                                        <td>{index + 1}</td>
                                                        <td>{data.opportunity_name}</td>
                                                        <td>{data.amount}</td>
                                                        <td>{data.stage}</td>
                                                        <td>{data.customer_name}</td>
                                                        <td>{data.company_name}</td>
                                                        <td><Moment format="DD-MM-YYYY">{data.close_date}</Moment></td>
                                                        <td>
                                                            <button type="submit" className="btn btn-primary me-2 savebtn" onClick={() => editOppurtunity(data)}>Edit</button>
                                                        </td>
                                                    </tr>))}
                                                </tbody>
                                            </table>
                                        </div>
                                    </div>
                                </div>
                            </div>



                        </div>
                    </div>
                    <Footer />
                </div>
            </div>
        </>
    )
}